import { utils as sharedUtils } from '@bond/utils'
import { setCookieConsent } from './setCookieConsent'
import { changeLanguage } from './changeLanguage'
import { toSpeakingUrl } from './toSpeakingUrl'
import { changeCity } from './changeCity'
import { getCreditsDiscount } from './credits/getCreditsDiscount'
import { getCreditsPrice } from './credits/getCreditsPrice'
import { initIntercom } from './chat/intercom'
import { metaPixelTrack } from './tracking/metaPixel'
import { initTracking } from './tracking/init'
import { googleAdsTrack, googleTagManagerTrack } from './tracking/google'
import { uniqueCategoriesFromStudios } from './uniqueCategoriesFromStudios'
import { getRoute } from './getRoute'
import { isPathnameHidden } from './isPathnameHidden'
import { formatFaqToStructuredData } from './formatFaqToStructuredData'
import { modifyStudioPartnerSignup } from './modifyFormData/studioPartnerSignup'

export const utils = {
  ...sharedUtils,
  chat: {
    intercom: {
      init: initIntercom,
    },
  },
  credits: {
    getDiscount: getCreditsDiscount,
    getPrice: getCreditsPrice,
  },
  modifyFormData: {
    studioPartnerSignup: modifyStudioPartnerSignup,
  },
  tracking: {
    google: {
      track: { ...googleTagManagerTrack, ...googleAdsTrack },
    },
    init: initTracking,
    metapixel: {
      track: metaPixelTrack,
    },
  },
  changeCity,
  changeLanguage,
  formatFaqToStructuredData,
  getRoute,
  isPathnameHidden,
  setCookieConsent,
  toSpeakingUrl,
  uniqueCategoriesFromStudios,
}
